<template>
  <div class="content-container">
    <div class="header-container">
      <div class="banner-container">
        <div class="banner">
          <Header />
        </div>

        <div class="brti-live-data">
          <div class="brti-box">
            <div class="brti-b">
              <div class="brti">BRTI</div>
              <div class="real-time">Real-Time Index</div>
            </div>

            <div class="brti-price">${{ this.formatNum(brtiData.value) }}</div>
            <div class="last-time">
              <span>Last Updated</span>
              <span> {{ this.lastTimes }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="body-container">
      <div class="body-box">
        <div class="charts-container">
          <div class="charts-box">
            <div style="display: flex; justify-content: space-between">
              <span @click="countClick">人数比值 ></span>
              <div class="lates-time">数据更新时间：{{ latestUpdateTime }}</div>
            </div>

            <div class="more-than-empty">
              <div class="assets-header">
                <div class="assets-bnt">
                  <el-radio-group @change="personChange" v-model="radio1" size="mini">
                    <el-radio-button label="15">15分钟</el-radio-button>
                    <el-radio-button label="30">30分钟</el-radio-button>
                    <el-radio-button label="60">60分钟</el-radio-button>
                    <el-radio-button label="1440">24小时</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="assets-body">
                <div class="right-control" v-show="this.Isvip1 == 2">
                  {{ isVipMsg3 }}
                </div>
                <chart v-show="this.Isvip1 !== 2" class="chart" :option="countOption" :style="{ width: '100%' }" />
              </div>
            </div>
          </div>
          <div class="charts-box">
            <div style="display: flex; justify-content: space-between">
              <span @click="priceClick">实盘金额多空比 ></span>
              <div class="lates-time">数据更新时间：{{ latestUpdateTime }}</div>
            </div>

            <div class="more-than-empty">
              <div class="assets-header">
                <div class="assets-bnt">
                  <el-radio-group @change="assetRatioChange" v-model="radio2" size="mini">
                    <el-radio-button label="15">15分钟</el-radio-button>
                    <el-radio-button label="30">30分钟</el-radio-button>
                    <el-radio-button label="60">60分钟</el-radio-button>
                    <el-radio-button label="1440">24小时</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="assets-body">
                <div class="right-control" v-show="this.Isvip2 == 2">
                  {{ isVipMsg4 }}
                </div>
                <chart class="chart" v-show="this.Isvip2 !== 2" :option="priceOption" :style="{ width: '100%' }" />
              </div>
            </div>
          </div>
        </div>
        <div class="ranking-list">
          <div class="charts-box">
            <span @click="allClick">用户收益排行榜 ></span>
            <div class="herader-banner">
              <div class="banner-tittle">
                <div class="select-tittle">{{ rankingTittle }}</div>
              </div>
            </div>
            <div class="leaderboard-button">
              <div class="btn-margin" v-infinite-scroll="load">
                <el-radio-group @change="runkChange" v-model="radio3" size="mini">
                  <el-radio-button v-for="item in runkTypeData" :key="item.id" :label="item.id">{{ item.name
                    }}</el-radio-button>
                </el-radio-group>
                <el-button class="all" @click="allClick">更多</el-button>
              </div>
            </div>
            <div class="leaderboard">
              <div class="mine-leaderboard">
                <div class="lead-box" style="display: flex" v-show="runkShow" ref="myRunk">
                  <div class="runk-left">
                    <div class="ranking">
                      <div class="num">{{ myRunk }}</div>
                    </div>
                    <div class="user">
                      <div class="user-img" @click="myUserClick()">
                        <img style="width: 34px; height: 34px; border-radius: 50%" :src="myAvatar" alt="" />
                        <img class="vip" :src="myImgUrl" alt="" />
                      </div>
                      <div class="user-name">
                        <div class="myName">{{ myUserName }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="price">
                    <span>
                      {{
                      this.userreType == 'mec' ||
                      this.userreType == 'qec' ||
                      this.userreType == 'aec'
                      ? myItem + '%'
                      : '$' + myItem
                      }}</span>
                  </div>
                </div>
                <div class="lead-box-error" style="display: none" v-show="!runkShow">
                  <span>{{ errorL }}</span>
                </div>
              </div>
              <div class="top-leaderboard">
                <el-table :data="userresData" border style="width: 100%">
                  <template slot="empty" v-if="Isvip == 2">
                    <!--  <img class="data-pic" src="#" alt="" />-->
                    <span style="font-size: 16px">{{ isVipMsg }}</span>
                  </template>
                  <el-table-column type="index" label="" class="ranking" width="77">
                    <template slot-scope="scope">
                      <div v-if="scope.$index + 1 == 1" class="topNo1">
                        <div class="top-num">TOP{{ scope.row.top }}</div>
                      </div>
                      <div v-if="scope.$index + 1 == 2" class="topNo2">
                        <div class="top-num">TOP{{ scope.row.top }}</div>
                      </div>
                      <div v-if="scope.$index + 1 == 3" class="topNo3">
                        <div class="top-num">TOP{{ scope.row.top }}</div>
                      </div>
                      <div v-else class="top">
                        <div class="top-num">TOP{{ scope.row.top }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="姓名">
                    <template slot-scope="scope">
                      <el-button type="text" class="user" @click="userClick(scope.row.targetUUID)">
                        <div class="user-img">
                          <div class="head-portrait">
                            <img :src="scope.row.avatar" alt="" />
                          </div>
                          <div class="vip">
                            <img v-show="scope.row.imgUrl !== ''" :src="scope.row.imgUrl" alt="" />
                          </div>
                        </div>
                        <div class="user-name">
                          <div v-if="
                              scope.$index + 1 == 1 ||
                              scope.$index + 1 == 2 ||
                              scope.$index + 1 == 3
                            " class="no1">
                            {{ scope.row.userName }}
                          </div>
                          <div v-else class="no">{{ scope.row.userName }}</div>
                        </div>
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" label="价格">
                    <template slot-scope="scope">
                      <div class="price">
                        <span>{{
                          scope.row.userreType == 'mec' ||
                          scope.row.userreType == 'aec'
                          ? scope.row.price + '%'
                          : '$' + scope.row.price
                          }}</span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="leaderboard-btn">
                <el-button type="text" @click="allClick">查看全部</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="body-box">
        <div class="container-row">
          <div class="charts-box">
            <span style="cursor: default">RTA分析部点阵图</span>
            <div class="total-user-assets dotmapDate-container">
              <div class="assets-header dotmapDate-box">
                <div class="box-he">
                  <div class="dotmapDate">
                    <div class="ditmap-i">
                      <i @click="goLast(1)" class="el-icon-arrow-left"></i>
                    </div>

                    <el-button size="small" type="text"></el-button>
                    <el-date-picker popper-class="dotmapPicker" v-model="selectDate2" value-format="yyyy-MM-dd"
                      type="date" size="small" width="120" placeholder="选择日期" :picker-options="expireTimeOption"
                      @change="getTimeChange">
                    </el-date-picker>
                    <div class="ditmap-i" :disabled="isDis" :style="{
                        color: changeColor,
                      }">
                      <i @click="goNextDay(1)" class="el-icon-arrow-right"></i>
                    </div>

                    <el-button size="small" type="text"></el-button>
                  </div>
                  <div class="r-switch" ref="disableedRef">
                    <el-switch v-model="showValue" active-color="" inactive-color="" :active-value="1"
                      :inactive-value="0" @change="changeShow">
                    </el-switch>
                  </div>
                </div>
              </div>
              <div class="assets-body dotmap-body">
                <div class="introducerKind">
                  <div class="chart-display">
                    <div class="aa">
                      <div class="cycle">
                        <tr>
                          <td class="long-box-te" style="text-align: left">
                            <div class="long-box">
                              <div class="long">多头</div>
                            </div>
                          </td>
                          <td>
                            <div class="vote-container" v-show="avaterShow">
                              <div class="vote" v-for="(item, index) in shortPoint.longData" :key="index">
                                <img :src="item.avatar" alt="" />
                                <div class="num" v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }">
                                  {{ item.num }}
                                </div>
                              </div>
                            </div>
                            <div class="vote-containe-round" v-show="roundShow">
                              <div class="vote" v-for="(item, index) in shortPoint.longData" :key="index">
                                <div class="round"></div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="box-te"></td>
                          <td>
                            <div class="vote-container" v-show="avaterShow">
                              <div class="vote" v-for="(item, index) in shortPoint.tooMachData" :key="index">
                                <img :src="item.avatar" alt="" />
                                <div v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }" class="num">
                                  {{ item.num }}
                                </div>
                              </div>
                            </div>
                            <div class="vote-containe-round" v-show="roundShow">
                              <div class="vote" v-for="(item, index) in shortPoint.tooMachData" :key="index">
                                <div class="round"></div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="long-box-te">
                            <div class="neutral-box">
                              <div class="neutral">中立</div>
                            </div>
                          </td>
                          <td>
                            <div class="vote-container" v-show="avaterShow">
                              <div class="vote" v-for="(item, index) in shortPoint.middleData" :key="index">
                                <img :src="item.avatar" alt="" />
                                <div v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }" class="num">
                                  {{ item.num }}
                                </div>
                              </div>
                            </div>
                            <div class="vote-containe-round" v-show="roundShow">
                              <div class="vote" v-for="(item, index) in shortPoint.middleData" :key="index">
                                <div class="round"></div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="box-te"></td>
                          <td>
                            <div class="vote-container" v-show="avaterShow">
                              <div class="vote" v-for="(item, index) in shortPoint.bearishData" :key="index">
                                <img :src="item.avatar" alt="" />
                                <div v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }" class="num">
                                  {{ item.num }}
                                </div>
                              </div>
                            </div>
                            <div class="vote-containe-round" v-show="roundShow">
                              <div class="vote" v-for="(item, index) in shortPoint.bearishData" :key="index">
                                <div class="round"></div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="long-box-te">
                            <div class="short-box">
                              <div class="short">空头</div>
                            </div>
                          </td>
                           <td class="long-box-te box-te">
                            <div class="neutral-box">
                              <div class="neutral">空头</div>
                            </div>
                          </td> -->
      <!-- <td>
        <div class="vote-container" v-show="avaterShow">
          <div class="vote" v-for="(item, index) in shortPoint.nullData" :key="index">
            <img :src="item.avatar" alt="" />
            <div class="num" v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }">
              {{ item.num }}
            </div>
          </div>
        </div>
        <div class="vote-containe-round" v-show="roundShow">
          <div class="vote" v-for="(item, index) in shortPoint.nullData" :key="index">
            <div class="round"></div>
          </div>
        </div>
      </td>
      </tr>
      <tr>
        <th></th>
        <td class="cy">短中期</td>
      </tr>
    </div>

    <div class="cycle"> -->
      <!-- <tr>
                          <td>
                            <div class="vote-container" v-show="avaterShow">
                              <div
                                class="vote"
                                v-for="(item, index) in midPoint.abstainData"
                                :key="index"
                              >
                                <img :src="item.avatar" alt="" />
                                <div
                                  class="num"
                                  v-show="item.num > 0"
                                  :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }"
                                >
                                  {{ item.num }}
                                </div>
                              </div>
                            </div>
                            <div class="vote-containe-round" v-show="roundShow">
                              <div
                                class="vote"
                                v-for="(item, index) in midPoint.abstainData"
                                :key="index"
                              >
                                <div class="round"></div>
                              </div>
                            </div>
                          </td>
                        </tr> -->
      <!-- <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in midPoint.longData" :key="index">
              <img :src="item.avatar" alt="" />
              <div class="num" v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in midPoint.longData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in midPoint.tooMachData" :key="index">
              <img :src="item.avatar" alt="" />
              <div class="num" v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in midPoint.tooMachData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in midPoint.middleData" :key="index">
              <img :src="item.avatar" alt="" />
              <div class="num" v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in midPoint.middleData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in midPoint.bearishData" :key="index">
              <img :src="item.avatar" alt="" />
              <div class="num" v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in midPoint.bearishData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in midPoint.nullData" :key="index">
              <img :src="item.avatar" alt="" />
              <div v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }" class="num">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in midPoint.nullData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="cy">中期</td>
      </tr>
    </div>

    <div class="cycle cycle-long"> -->
      <!-- <tr>
                          <td>
                            <div class="vote-container" v-show="avaterShow">
                              <div
                                class="vote"
                                v-for="(item, index) in longPoint.abstainData"
                                :key="index"
                              >
                                <img :src="item.avatar" alt="" />
                                <div
                                  v-show="item.num > 0"
                                  :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }"
                                  class="num"
                                >
                                  {{ item.num }}
                                </div>
                              </div>
                            </div>
                            <div class="vote-containe-round" v-show="roundShow">
                              <div
                                class="vote"
                                v-for="(item, index) in longPoint.abstainData"
                                :key="index"
                              >
                                <div class="round"></div>
                              </div>
                            </div>
                          </td>
                        </tr> -->
      <!-- <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in longPoint.longData" :key="index">
              <img :src="item.avatar" alt="" />
              <div v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }" class="num">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in longPoint.longData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in longPoint.tooMachData" :key="index">
              <img :src="item.avatar" alt="" />
              <div v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }" class="num">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in longPoint.tooMachData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in longPoint.middleData" :key="index">
              <img :src="item.avatar" alt="" />
              <div v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }" class="num">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in longPoint.middleData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in longPoint.bearishData" :key="index">
              <img :src="item.avatar" alt="" />
              <div v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }" class="num">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in longPoint.bearishData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="vote-container" v-show="avaterShow">
            <div class="vote" v-for="(item, index) in longPoint.nullData" :key="index">
              <img :src="item.avatar" alt="" />
              <div v-show="item.num > 0" :style="{
                                    color:
                                      item.PositionSide == '空'
                                        ? 'rgba(247, 82, 95, 1)'
                                        : 'rgba(0, 174, 147, 1)',
                                  }" class="num">
                {{ item.num }}
              </div>
            </div>
          </div>
          <div class="vote-containe-round" v-show="roundShow">
            <div class="vote" v-for="(item, index) in longPoint.nullData" :key="index">
              <div class="round"></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="cy">长期</td>
      </tr>
    </div>
  </div>
  </div>
  </div>
  <div></div>
  <div class="dotmap-tittle">仅供参考 不构成投资建议</div>
  </div>
  </div>
  </div>
  </div>
  </div> -->
      <div class="body-box">
        <div class="container-row">
          <div class="charts-box">
            <span style="cursor: default">RTA用户总资产规模</span>
            <div class="total-user-assets">
              <div class="assets-header">
                <div class="assets-tittle">
                  <div class="accumulated">总资产（USD）</div>
                  <div class="price">{{ assetC }}</div>
                  <div class="data">
                    数据截止<span>{{ assetDate }}</span>
                  </div>
                </div>
                <div class="assets-bnt">
                  <el-radio-group @change="assetChange" v-model="radio4" size="mini">
                    <el-radio-button label="month">近一月</el-radio-button>
                    <el-radio-button label="halfYear">近半年</el-radio-button>
                    <el-radio-button label="allYear">近一年</el-radio-button>
                    <el-radio-button label="all">全部</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="assets-body">
                <div class="right-control" v-show="this.Isvip3 == 2">
                  {{ isVipMsg1 }}
                </div>
                <div class="charts">
                  <!-- <AreaChart ref="assetsChart" /> -->
                  <chart v-show="this.Isvip3 !== 2" class="chart" :option="assetsOption" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body-box">
        <div class="container-row">
          <div class="charts-box">
            <span style="cursor: default">RTA全体用户收益情况</span>
            <div class="total-user-assets">
              <div class="assets-header">
                <div class="assets-tittle">
                  <div class="accumulated">累计收益（USD）</div>
                  <div class="price price-user">{{ earningCount }}</div>
                  <div class="data">
                    数据截止<span>{{ earningDate }}</span>
                  </div>
                </div>
                <div class="assets-bnt">
                  <el-radio-group @change="earningChange" v-model="radio5" size="mini">
                    <el-radio-button label="month">近一月</el-radio-button>
                    <el-radio-button label="halfYear">近半年</el-radio-button>
                    <el-radio-button label="allYear">近一年</el-radio-button>
                    <el-radio-button label="all">全部</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="assets-body">
                <div class="charts">
                  <!-- <AreaChart ref="earningsChart" /> -->
                  <div class="right-control" v-show="this.Isvip4 == 2">
                    {{ isVipMsg2 }}
                  </div>
                  <chart v-show="this.Isvip4 !== 2" class="chart" :option="earningOption" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getUserAsset } from '../api/User';
  import {
    getRtainfoData,
    getCountAssetRatio,
    getHomeRunking,
    getMyrank,
    sendPointShow,
  } from '@/api/Home.js';
  import Header from './Header.vue';
  import Chart from '../echarts/chart.vue';
  export default {
    name: 'Home',
    components: { Header, Chart },
    data() {
      return {
        lastTimes: '',
        accountId: '',
        brtiData: {
          value: 0,
          date: '',
        },
        assetCount: '',
        assetDate: '',
        earningCount: '',
        earningDate: '',
        radio1: '15',
        radio2: '15',
        radio3: 'me',
        radio4: 'all',
        radio5: 'all',
        top: '0',
        latestUpdateTime: '',
        userresData: [],
        priceOption: {},
        countOption: {},
        assetsOption: {},
        earningOption: {},
        assetsXData: [],
        assetsYData: [],
        earningXData: [],
        earningYData: [],
        assetC: '',
        personCount: {
          longPersonsCount: '',
          noPositionPersonsCount: '',
          shortPersonsCount: '',
        },
        assetCount: {
          longAssetCount: '',
          shortAssetCount: '',
        },
        rankingTittle: '',
        runkTypeData: [
          {
            id: 'me',
            name: '月收益',
          },
          {
            id: 'mec',
            name: '月收益率',
          },

          {
            id: 'ae',
            name: '总收益',
          },
          {
            id: 'aec',
            name: '总收益率',
          },
          {
            id: 'aa',
            name: '总资产',
          },
        ],
        radioName: {
          me: '月收益',
          mec: '月收益率',
          ae: '总收益',
          aec: '总收益率',
          aa: '总资产',
        },
        userreType: '',
        myRunk: '',
        myUserName: '',
        myItem: '',
        myAvatar: '',
        myVipName: '',
        myImgUrl: '',
        myUuid: '',
        runkShow: false,
        errorL: '您暂无排名！',
        imgUrl: '',
        Isvip: '',
        isVipMsg: '',
        isVipMsg1: '',
        isVipMsg2: '',
        isVipMsg3: '',
        isVipMsg4: '',
        Isvip1: '',
        Isvip2: '',
        Isvip3: '',
        Isvip4: '',
        selectDate: '',
        selectDate2: '',
        showValue: false,
        expireTimeOption: {
          disabledDate(date) {
            // disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
            return date.getTime() >= Date.now();
          },
        },
        shortPoint: {},
        midPoint: {},
        longPoint: {},
        avaterShow: false,
        roundShow: true,
        isNull: true,
        isPointShow: true,
        isDisabled: true,
        changeColor: '',
        isDis: true,
      };
    },
    created() {
      this.initWebSocket();
      this.getPersonCount();
      this.getAssetRatio();
      this.getRunkData();
      this.findMyRunk();
      this.getAsset();
      this.getEarning();
      this.priceChange();
      this.countChange();
      this.assetsChange();
      this.earningsChange();
      this.getNowTime();
      //this.findBitmapInformationData()
    },
    mounted() {
      this.load_data();
      //图表自适应大小
      //window.addEventListener('resize', this.chart.resize);
    },
    directives: {
      focus: {
        inserted: function (el) {
          el.focus();
        },
      },
    },
    methods: {
      async load_data() {
        var theme = localStorage.getItem('token');
        if (theme == null || theme == '') {
          // 未登录不显示用户信息
          this.$refs.popoverRef.style.display = 'none';
        } else {
          // 显示用户信息
          const userInfo = JSON.parse(localStorage.getItem('userInfo'));
          this.isPointShow = userInfo.isPointShow;
          if (this.isPointShow == true) {
            this.$refs.disableedRef.style.display = 'flex';
          } else {
            this.$refs.disableedRef.style.display = 'none';
          }
        }
      },
      //将10位或者13位时间戳转化为日期格式
      timestampToTime(timestamp) {
        if (String(timestamp).length == 10) {
          var unixtimestamp = new Date(timestamp * 1000);
          var year = 1900 + unixtimestamp.getYear();
          var month = '0' + (unixtimestamp.getMonth() + 1);
          var date = '0' + unixtimestamp.getDate();
          var hour = '0' + unixtimestamp.getHours();
          var minute = '0' + unixtimestamp.getMinutes();
          var second = '0' + unixtimestamp.getSeconds();
          return (
            year +
            '-' +
            month.substring(month.length - 2, month.length) +
            '-' +
            date.substring(date.length - 2, date.length) +
            ' ' +
            hour.substring(hour.length - 2, hour.length) +
            ':' +
            minute.substring(minute.length - 2, minute.length) +
            ':' +
            second.substring(second.length - 2, second.length)
          );
        } else {
          let currentTime = new Date(timestamp);
          let year = currentTime.getFullYear(),
            month = currentTime.getMonth() + 1,
            day = currentTime.getDate(),
            hour = currentTime.getHours(),
            minute = currentTime.getMinutes(),
            second = currentTime.getSeconds(),
            millSeconds = currentTime.getMilliseconds();
          let months = month < 10 ? '0' + month : month,
            days = day < 10 ? '0' + day : day,
            hours = hour < 10 ? '0' + hour : hour,
            minutes = minute < 10 ? '0' + minute : minute,
            seconds = second < 10 ? '0' + second : second,
            millSecondss =
              millSeconds < 10
                ? '00' + millSeconds
                : millSeconds < 100
                  ? '0' + millSeconds
                  : millSeconds;
          return (
            year +
            '-' +
            months +
            '-' +
            days +
            ' ' +
            hours +
            ':' +
            minutes +
            ':' +
            seconds +
            '.' +
            millSecondss
          );
        }
      },
      //显示当前时间
      getNowTime() {
        let now = new Date(),
          year = now.getFullYear(), //得到年份
          month = now.getMonth() + 1, //得到月份
          date = now.getDate(); //得到日期

        let time = year + '-' + month + '-' + date;
        this.selectDate = time;
        this.selectDate2 = '';
        this.findBitmapInformationData();
      },
      //上一日
      goLast(index) {
        if (index === 0) {
          let date1 = new Date(this.selectDate).getTime() - 3600 * 1000 * 24;
          this.selectDate = this.timestampToTime(date1).substring(0, 10);
          this.findBitmapInformationData();
        } else if (index === 1) {
          this.changeColor = 'rgba(255, 255, 255, 1)';
          let date2 = new Date(this.selectDate2).getTime() - 3600 * 1000 * 24;
          this.selectDate2 = this.timestampToTime(date2).substring(0, 10);
          this.findBitmapInformationData();
        }
      },

      //下一日
      goNextDay(index) {
        if (index === 0) {
          let date3 = new Date(this.selectDate).getTime() + 3600 * 1000 * 24;
          this.selectDate = this.timestampToTime(date3).substring(0, 10);
          this.findBitmapInformationData();
        } else if (index === 1) {
          let date4 = new Date(this.selectDate2).getTime() + 3600 * 1000 * 24;
          const aaa = this.dateTypeFormat('YYYY-mm-dd', new Date());
          const bbb = this.dateTypeFormat('YYYY-mm-dd', new Date(date4));
          if (bbb <= aaa) {
            this.changeColor = 'rgba(255, 255, 255, 1)';
            this.selectDate2 = this.timestampToTime(date4).substring(0, 10);
            this.findBitmapInformationData();
          } else {
            this.changeColor = 'rgba(209,212,220,0.5)';
          }
        }
      },

      eosFormatTime2() {
        var time1 = oldTimes1.split(' ')[0];
        // console.log("1、第二种方式time1:" + time1)
        var arrTime = oldTimes1.split(' ')[1].split(':');
        // console.log("2、第二种方式arrTime:" + arrTime)
        var time2 = arrTime.slice(1, arrTime.length).join(':');
        // console.log("3、第二种方式time2:" + time2)
        var h = parseInt(arrTime[0]) + 8;
        // console.log('4、第二种方式小时：', h);
        var newH = (h < 24 ? h : h % 24).toString();
        return time1 + ' ' + newH + ':' + time2;
      },
      load() {
        this.count += 2;
      },
      changeShow(statu) {
        if (!statu) {
          this.avaterShow = false;
          this.roundShow = true;
        } else {
          this.avaterShow = true;
          this.roundShow = false;
        }
      },
      //RTA分析部点阵图选择时间事件
      getTimeChange() {
        //console.log('ffffffff', this.selectDate2);
        const aaa = this.dateTypeFormat('YYYY-mm-dd', new Date());
        const ccc = this.dateTypeFormat('YYYY-mm-dd', new Date(this.selectDate2));
        //console.log('1111', ccc);
        if (ccc < aaa) {
          this.changeColor = 'rgba(rgba(255, 255, 255, 1))';
          this.isDis == false; //2023-03-14
        } else {
          this.isDis == true;
          this.changeColor = 'rgba(209,212,220,0.5)';
          // this.$refs.downRef.style.
        }
        this.findBitmapInformationData();
      },
      //使用 WebSocket 实时获取BRTI数据信息
      initWebSocket() {
        this.websock = null;
        //判断当前浏览器是否支持WebSocket
        if ('WebSocket' in window) {
          //初始化weosocket(必须)
          this.websock = new WebSocket('wss://crypto.cmegroup.com/'); //新建一个webstock对象
          this.websock.onopen = this.websocketonopen;
          this.websock.onmessage = this.websocketonmessage;
          this.websock.onerror = this.websocketonerror;
          this.websock.onclose = this.websocketclose;
        } else {
          alert('当前浏览器 Not support websocket');
        }
      },
      websocketonopen() { },
      websocketonerror() {
        //连接建立失败重连
        this.initWebSocket();
      },
      websocketonmessage(e) {
        //数据接收
        let dataObj = JSON.parse(e.data);
        if (dataObj.symbol === 'BRTI') {
          this.brtiData = dataObj;

          var oldTimes = this.brtiData.date;
          var eosFormatTime2 = function (oldTimes) {
            var time1 = oldTimes.split(' ')[0];
            // console.log("1、第二种方式time1:" + time1)
            var arrTime = oldTimes.split(' ')[1].split(':');
            // console.log("2、第二种方式arrTime:" + arrTime)
            var time2 = arrTime.slice(1, arrTime.length).join(':');
            // console.log("3、第二种方式time2:" + time2)
            var h = parseInt(arrTime[0]) + 8;
            // console.log('4、第二种方式小时：', h);
            var newH = (h < 24 ? h : h % 24).toString();
            return time1 + ' ' + newH + ':' + time2;
          };
          this.lastTimes = eosFormatTime2(oldTimes);
          // console.log(eosFormatTime2(this.lastTimes));
        }
      },
      websocketsend(Data) {
        //数据发送
        this.websock.send(Data);
      },
      websocketclose(e) {
        //关闭
        // console.log("断开连接", e);
      },

      //获取点阵图信息
      async findBitmapInformationData() {
        const { data: res } = await sendPointShow(this.selectDate2);

        if (res.code == 0) {
          let pointArr = res.data;
          if (pointArr.length > 0) {
            this.selectDate2 = pointArr[0].date;
            const keyName = {
              弃票: 'abstainData',
              多头: 'longData',
              震荡偏多: 'tooMachData',
              中立: 'middleData',
              震荡偏空: 'bearishData',
              空头: 'nullData',
            };
            for (const key in keyName) {
              this.shortPoint[keyName[key]] = [];
              this.midPoint[keyName[key]] = [];
              this.longPoint[keyName[key]] = [];
            }

            pointArr.forEach((item) => {
              const {
                user,
                longPositionLeverage,
                longPoint,
                midPoint,
                midPositionLeverage,
                shortPoint,
                shortPositionLeverage,
                shortPositionSide,
                midPositionSide,
                longPositionSide,
              } = item;
              this.shortPoint[keyName[shortPoint]].push({
                avatar: user.avatar,
                num: shortPositionLeverage,
                point: shortPoint,
                PositionSide: shortPositionSide,
              });
              this.midPoint[keyName[midPoint]].push({
                avatar: user.avatar,
                num: midPositionLeverage,
                point: midPoint,
                PositionSide: midPositionSide,
              });
              this.longPoint[keyName[longPoint]].push({
                avatar: user.avatar,
                num: longPositionLeverage,
                point: longPoint,
                PositionSide: longPositionSide,
              });
              const aaa = this.dateTypeFormat('YYYY-mm-dd', new Date());
              if (this.selectDate2 < aaa) {
                this.changeColor = 'rgba(rgba(255, 255, 255, 1))';
                this.isDis == false; //2023-03-14
              } else {
                this.isDis == true;
                this.changeColor = 'rgba(209,212,220,0.5)';
                // this.$refs.downRef.style.
              }
            });
          } else {
            this.shortPoint = [];
            this.midPoint = [];
            this.longPoint = [];
          }
        }
      },

      //人数比值date切换事件
      personChange(value) {
        this.radio1 = value;
        this.getPersonCount();
      },
      //获取人数比值所有数据
      getPersonCount() {
        const res = getCountAssetRatio({
          minutes: this.radio1,
        });
        res
          .then((success) => {
            if (success.data.code == 10001) {
              this.$message.error('请求时间暂无数据!');
              this.longPersonsCount = 0;
              this.noPositionPersonsCount = 0;
              this.shortPersonsCount = 0;
              this.countChange();
            } else if (success.data.code == 10006) {
              this.Isvip1 = 2;
              this.isVipMsg1 = res.msg;
            } else {
              //console.log(success.data.data.createTime);
              this.latestUpdateTime = this.timeArr = this.dateTypeFormat(
                'YYYY-mm-dd HH:MM',
                new Date(success.data.data.createTime)
              );
              this.longPersonsCount =
                success.data.data.personCount.longPersonsCount;
              this.noPositionPersonsCount =
                success.data.data.personCount.noPositionPersonsCount;
              this.shortPersonsCount =
                success.data.data.personCount.shortPersonsCount;
              this.countChange();
            }
          })
          .catch((error) => {
            if (error.data.msg == 'token不存在！') {
              this.Isvip1 = 2;
              this.isVipMsg3 = '请登录后查看数据！';
            }
          });
      },
      //实盘人数多空
      countChange() {
        let dataPie2 = [
          {
            name: '多头',
            value: this.longPersonsCount,
          },
          {
            name: '未开仓',
            value: this.noPositionPersonsCount,
          },
          {
            name: '空头',
            value: this.shortPersonsCount,
          },
        ];
        let dataColor2 = [
          {
            type: 'linear',
            x: 0,
            x2: 0,
            y: 1,
            y2: 0,
            colorStops: [
              { offset: 1, color: 'rgba(132, 249, 229, 1)' },
              { offset: 0, color: 'rgba(34, 171, 148, 1)' },
            ],
          },
          {
            type: 'linear',
            x: 0,
            x2: 0,
            y: 1,
            y2: 0,
            colorStops: [
              { offset: 0, color: 'rgba(235, 240, 255, 1)' },
              { offset: 1, color: 'rgba(209, 212, 220, 1)' },
            ],
          },
          {
            type: 'linear',
            x: 0,
            x2: 0,
            y: 1,
            y2: 0,
            colorStops: [
              { offset: 0, color: 'rgba(255, 184, 189, 1)' },
              { offset: 1, color: 'rgba(247, 82, 95, 1)' },
            ],
          },
        ];
        let legendData = [],
          seriesData = [],
          radiusValue = 50,
          total = 0;
        let startAngle = [];

        total = dataPie2.reduce((a, c) => a + c.value, 0);

        dataPie2.reduce((a, c) => {
          startAngle.push((a / total) * 360);
          return a + c.value;
        }, 0);
        for (var i = 0; i < dataPie2.length; i++) {
          legendData.push(dataPie2[i].name);
          seriesData.push({
            type: 'pie',
            clockWise: true, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: true,
            radius: [
              radiusValue - 10 * i + '%',
              radiusValue - 9 - 10 * i + 1 + '%',
            ],
            center: ['50%', '43%'],
            label: {
              normal: {
                show: true,
                color: '#D1D4DC',
                lineHeight: 1,
                fontSize: 18,
                // formatter: '失效片'+ '{c}',
                formatter: function (v, name) {
                  let space = ' ';
                  let percent;
                  percent = ((v.value / total) * 100).toFixed(2);
                  let text =
                    '{hr|}' +
                    '\n' +
                    space +
                    space +
                    v.name +
                    percent +
                    '%' +
                    space +
                    space;
                  return text;
                },
                //formatter: '\n{hr|}{n|}\n{b}{c}%',
                rich: {
                  hr: {
                    // backgroundColor:"auto",
                    borderType: 'solid',
                    borderColor: 'auto',
                    borderRadius: 20,
                    borderWidth: 1,
                    hright: 1,
                    padding: [-8, 5, 2, -10],
                  },
                  a: {
                    width: 10,
                    padding: [-10, 10, -10, 15],
                    align: 'center',
                  },
                  b: {
                    align: 'center',
                  },
                },
              },
            },
            labelLine: {
              normal: {
                showAbove: true,
                length: 75,
                length2: 45,
                show: true,
              },
            },
            hoverAnimation: false, //关闭 hover 在扇区上的放大动画效果
            startAngle: 270 + startAngle[i], //起始角度
            // startAngle: 35 - startAngle[i] - startAngle[i], //起始角度
            data: [
              {
                //透明伞形
                z: 1,
                value: total - dataPie2[i].value,
                label: {
                  show: false,
                },
                itemStyle: {
                  //设置透明伞形
                  color: 'rgba(51, 53, 62, 1)', //伞形颜色
                  label: {
                    show: false,
                  },
                },
                labelLine: {
                  show: false,
                },
              },
              {
                z: 2,
                value: dataPie2[i].value,
                name: dataPie2[i].name,

                itemStyle: {
                  borderRadius: '50%',
                  color: dataColor2[i],
                },
              },
            ],
          });
        }
        this.countOption = {
          legend: {
            data: legendData,
            icon: 'roundRect',
            top: 'bottom',
            padding: [0, 0, 4, 0],
            itemGap: 40,
            itemWidth: 16,
            itemHeight: 16,
            formatter: function (name) {
              let target, percent;
              for (let i = 0; i < dataPie2.length; i++) {
                if (dataPie2[i].name === name) {
                  target = dataPie2[i].value;
                  percent = ((target / total) * 100).toFixed(2);
                }
              }
              let arr = [name + ' ' + target + '人'];
              return arr.join('\n');
            },
            textStyle: {
              fontSize: 14,
              color: '#fff',
            },
          },
          radar: {
            radius: 80,
          },
          series: seriesData,
        };
      },

      //金额比值date切换事件
      assetRatioChange(value) {
        this.radio2 = value;
        this.getAssetRatio();
      },
      //获取金额比值所有数据
      getAssetRatio() {
        const res = getCountAssetRatio({
          minutes: this.radio2,
        });
        res
          .then((success) => {
            if (success.data.code == 10001) {
              this.$message.error('请求时间暂无数据!');
              this.longAssetCount = 0;
              this.shortAssetCount = 0;
              this.priceChange();
            } else if (success.data.code == 10006) {
              this.Isvip2 = 2;
              this.isVipMsg2 = res.msg;
            } else {
              this.longAssetCount = success.data.data.assetCount.longAssetCount;
              this.shortAssetCount = success.data.data.assetCount.shortAssetCount;
              this.priceChange();
            }
          })
          .catch((error) => {
            if (error.data.msg == 'token不存在！') {
              this.Isvip2 = 2;
              this.isVipMsg4 = '请登录后查看数据！';
            }
          });
      },
      //实盘金额多空
      priceChange() {
        let dataPie2 = [
          {
            name: '多头',
            value: this.longAssetCount,
          },
          {
            name: '空头',
            value: this.shortAssetCount,
          },
        ];
        let dataColor2 = [
          {
            type: 'linear',
            x: 0,
            x2: 0,
            y: 1,
            y2: 0,
            colorStops: [
              { offset: 1, color: 'rgba(132, 249, 229, 1)' },
              { offset: 0, color: 'rgba(34, 171, 148, 1)' },
            ],
          },
          {
            type: 'linear',
            x: 0,
            x2: 0,
            y: 1,
            y2: 0,
            colorStops: [
              { offset: 0, color: 'rgba(255, 184, 189, 1)' },
              { offset: 1, color: 'rgba(247, 82, 95, 1)' },
            ],
          },
        ];
        let legendData = [],
          seriesData = [],
          radiusValue = 50,
          total = 0;
        let startAngle = [];

        total = dataPie2.reduce((a, c) => a + c.value, 0);

        dataPie2.reduce((a, c) => {
          startAngle.push((a / total) * 360);
          return a + c.value;
        }, 0);
        for (var i = 0; i < dataPie2.length; i++) {
          legendData.push(dataPie2[i].name);
          seriesData.push({
            type: 'pie',
            clockWise: true, //饼图的扇区是否是顺时针排布
            radius: [
              radiusValue - 10 * i + '%',
              radiusValue - 9 - 10 * i + 1 + '%',
            ],
            center: ['50%', '43%'],
            label: {
              normal: {
                color: '#D1D4DC',
                lineHeight: 2,
                fontSize: 18,
                // formatter: '\n{hr|}\n{b}{c}%',
                formatter: function (v) {
                  let space = ' ';
                  let percent;
                  percent = ((v.value / total) * 100).toFixed(2);
                  let text =
                    '{hr|}' +
                    '\n' +
                    space +
                    space +
                    v.name +
                    percent +
                    '%' +
                    space +
                    space;
                  return text;
                },
                rich: {
                  hr: {
                    // backgroundColor:"auto",
                    borderType: 'solid',
                    borderColor: 'auto',
                    borderRadius: 20,
                    borderWidth: 1,
                    hright: 1,
                    padding: [-6, 5, -1, -10],
                  },
                  a: {
                    width: 10,
                    padding: [-10, 10, -10, 15],
                    align: 'center',
                  },
                  b: {
                    align: 'center',
                  },
                },
              },
            },
            labelLine: {
              normal: {
                length: 75,
                length2: 45,
                show: true,
              },
            },
            hoverAnimation: false, //关闭 hover 在扇区上的放大动画效果
            startAngle: 270 + startAngle[i], //起始角度
            // startAngle: 35 - startAngle[i] - startAngle[i], //起始角度
            data: [
              {
                //透明伞形
                z: 1,
                value: total - dataPie2[i].value,
                label: {
                  show: false,
                },
                itemStyle: {
                  //设置透明伞形
                  color: 'rgba(51, 53, 62, 1)', //伞形颜色
                  label: {
                    show: false,
                  },
                },
                labelLine: {
                  show: false,
                },
              },
              {
                z: 2,
                value: dataPie2[i].value,
                name: dataPie2[i].name,

                itemStyle: {
                  borderRadius: '50%',
                  color: dataColor2[i],
                },
              },
            ],
          });
        }
        this.priceOption = {
          legend: {
            data: legendData,
            icon: 'roundRect',
            top: 'bottom',
            padding: [0, 0, 4, 0],
            itemGap: 40,
            itemWidth: 16,
            itemHeight: 16,
            formatter: function (name) {
              let target, percent;
              for (let i = 0; i < dataPie2.length; i++) {
                if (dataPie2[i].name === name) {
                  let value = '';
                  if (dataPie2[i].value >= 0) {
                    value = dataPie2[i].value.toFixed(2);
                    if (value > 999) {
                      // 数值加千分号
                      let parts = value.toString().split('.');
                      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                      value = parts.join('.');
                    }
                  }

                  target = value;
                  percent = ((target / total) * 100).toFixed(2);
                }
              }

              let arr = [name + ' ' + '$' + target];
              return arr.join('\n');
            },
            textStyle: {
              fontSize: 14,
              color: '#fff',
            },
          },
          radar: {
            radius: 80,
          },
          series: seriesData,
        };
      },
      myUserClick() {
        this.$router.replace({
          path: '/User',
        });
      },
      //排行榜点击跳转用户详情
      async userClick(id) {
        let params = {
          targetUUID: id,
          accountId: this.accountId,
        };
        const { data: res } = await getUserAsset(params);

        let userName = res.data.user.userName;

        if (res.code == 10001 || res.code == 10006) {
          this.$alert(res.msg, '提示', {
            customClass: 'permissions_alert',
          });
          // alert(res.msg);
          return;
        }
        this.$router.replace({
          path: '/User',
          query: {
            targetUUID: id,
            accountId: this.accountId,
            userName: userName,
          },
        });
      },
      //点击查看全部用户收益排行榜
      allClick() {
        this.$router.replace({ path: '/AllleaderBoard' });
      },
      //排行榜查询类型筛选
      runkChange(value) {
        this.radio3 = value;
        this.userresData = [];
        this.getRunkData();
        this.findMyRunk();
      },
      // //获取排行榜全部数据
      getRunkData(id) {
        const res = getHomeRunking({
          queryType: this.radio3,
        });
        res
          .then((success) => {
            if (success.data.code == 0) {
              let userres = success.data.data;
              userres.forEach((item) => {
                this.userreType = this.radio3;
                const userresObj = {
                  top: item.rank,
                  avatar: item.user.avatar,
                  userName: item.user.userName,
                  price: this.formatNum(item.item),
                  vipName: item.user.vipName,
                  targetUUID: item.user.uuid,
                  userreType: this.userreType,
                  imgUrl: this.imgUrl,
                };
                this.userresData.push(userresObj);
              });
              this.userresData.forEach((item) => {
                //console.log(item.avatar)
                var text = item.vipName;
                if (text == null) {
                  item.imgUrl = '';
                } else {
                  // this.imgUrl = require('@/assets/images/inventory/' + text + '.svg');
                  //console.log('@/assets/images/inventory/' + text + '.svg');
                  switch (text) {
                    case 'A1':
                      item.imgUrl = require('@/assets/img/rtaLogo/A1.svg');
                      break;
                    case 'A2':
                      item.imgUrl = require('@/assets/img/rtaLogo/A2.svg');
                      break;
                    case 'A3':
                      item.imgUrl = require('@/assets/img/rtaLogo/A3.svg');
                      break;
                    case 'A4':
                      item.imgUrl = require('@/assets/img/rtaLogo/A4.svg');
                      break;
                    case 'A5':
                      item.imgUrl = require('@/assets/img/rtaLogo/A5.svg');
                      break;
                    case 'A6':
                      item.imgUrl = require('@/assets/img/rtaLogo/A6.svg');
                      break;
                    case 'A7':
                      item.imgUrl = require('@/assets/img/rtaLogo/A7.svg');
                      break;
                    case 'A8':
                      item.imgUrl = require('@/assets/img/rtaLogo/A8.svg');
                      break;
                    case 'A9':
                      item.imgUrl = require('@/assets/img/rtaLogo/A9.svg');
                      break;
                  }
                }
              });
              //获取收益筛选类型标题
              let obj = this.radioName;
              //console.log(this.radio);
              let key = this.radio3;
              this.rankingTittle = obj[key];
            } else if (success.data.code == 10006) {
              //this.$message.error(res.msg);
              this.Isvip = 2;
              this.isVipMsg = res.msg;
            }
          })
          .catch((error) => {
            if (error.data.msg == 'token不存在！') {
              this.Isvip2 = 2;
              this.isVipMsg = '请登录后查看数据！';
            }
          });
      },

      //获取我的排名全部数据
      findMyRunk() {
        const res = getMyrank({
          queryType: this.radio3,
        });
        res
          .then((success) => {
            if (success.data.msg == '暂无您的排名') {
              this.runkShow = false;
              this.errorL = '暂无您的排名！';
            } else if (success.data.code == 10006) {
              this.runkShow = false;
              this.errorL = success.data.msg;
            } else {
              this.runkShow = true;
              let myRunks = success.data.data;
              this.userreType = this.radio3;
              //console.log('我的排名数据', myRunks);
              this.myRunk = myRunks.rank;
              this.myUserName = myRunks.user.userName;
              this.myItem = this.formatNum(myRunks.item);
              this.myAvatar = myRunks.user.avatar;
              this.myVipName = myRunks.user.vipName;
              this.myUuid = myRunks.user.uuid;
              //console.log(this.myUuid)

              if (this.myVipName == null) {
                this.myImgUrl = '';
              } else {
                switch (this.myVipName) {
                  case '高级会员V1':
                    this.myImgUrl = require('@/assets/img/rtaLogo/V1.svg');
                    break;
                  case '高级会员V2':
                    this.myImgUrl = require('@/assets/img/rtaLogo/V2.svg');
                    break;
                  case '超级会员':
                    this.myImgUrl = require('@/assets/img/rtaLogo/SVIP.svg');
                    break;
                }
              }
            }
          })
          .catch((error) => {
            if (error.data.msg == 'token不存在！') {
              this.runkShow = false;
              this.errorL = '请登录后查看个人排名！';
            }
          });
      },

      //点击查看全部人数比值
      countClick() {
        this.$router.replace({ path: '/CountHistory' });
      },
      //点击查看全部实盘金额多空比
      priceClick() {
        this.$router.replace({ path: '/PriceHistory' });
      },
      //资产规模date切换事件
      assetChange(value) {
        this.radio4 = value;
        this.getAsset();
      },
      //获取RTA资产规模全部数据
      getAsset() {
        const res = getRtainfoData({
          type: this.radio4,
        });
        res
          .then((success) => {
            if (success.data.code == 10006 || res.code == 10001) {
              this.Isvip3 = 2;
              this.isVipMsg3 = res.msg;
            } else if (success.data.code == 0) {
              if (success.data.data.length !== 0) {
                let AllData = success.data.data;
                //console.log('资产规模', AllData);
                this.assetsXData = AllData.map((v) => v.date);
                this.assetsYData = AllData.map((v) => v.asset);
                //console.log(this.assetsYData, this.assetsXData);
                this.assetC = this.formatNum(AllData[0].asset);
                this.assetDate = AllData[0].date;
                this.assetsChange();
              } else {
                this.$message.error('当前资产规模暂无数据！');
                this.assetsXData = [];
                this.assetsYData = [];
                this.assetC = '';
                this.assetDate = '';
              }
            }
          })
          .catch((error) => {
            if (error.data.msg == 'token不存在！') {
              this.Isvip3 = 2;
              this.isVipMsg1 = '请登录后查看数据！';
            }
          });
      },
      //用户收益date切换事件
      earningChange(value) {
        this.radio5 = value;
        this.getEarning();
      },
      //获取RTA用户收益全部数据
      getEarning() {
        const res = getRtainfoData({
          type: this.radio5,
        });
        res
          .then((success) => {
            //console.log('请求成功', success);
            if (success.data.code == 10006 || success.data.code == 10001) {
              this.Isvip4 = 2;
              this.isVipMsg4 = res.msg;
            } else if (success.data.code == 0) {
              if (success.data.data.length != 0) {
                let AllData = success.data.data;
                //console.log("用户收益",AllData)
                this.earningXData = AllData.map((v) => v.date);
                this.earningYData = AllData.map((v) => v.earning);
                //console.log(this.earningXData, this.earningYData);
                this.earningCount = this.formatNum(AllData[0].earning);
                this.earningDate = AllData[0].date;
                this.earningsChange();
              } else {
                this.$message.error('当前用户收益暂无数据！');
                this.earningXData = [];
                this.earningYData = [];
                this.earningCount = '';
                this.earningDate = '';
              }
            }
          })
          .catch((error) => {
            if (error.data.msg == 'token不存在！') {
              this.Isvip4 = 2;
              this.isVipMsg2 = '请登录后查看数据！';
            }
          });
      },

      //RTA用户总资产规模
      assetsChange() {
        this.assetsOption = {
          color: 'rgba(0, 174, 147, 1)',
          tooltip: {
            trigger: 'axis',
            borderWidth: '0', //边框宽度设置1
            borderColor: 'none', //设置边框颜色
            // formatter:
            //   '{b} <br/>{a}: <span style="color:#EDBD88;font-size:16px;">{c}',
            formatter: (params) => {
              let result = `${params[0].name}<br>`;

              params.forEach((item) => {
                var aaa = this.kmb(item.value);
                result += `${item.seriesName} : <span style="color:#EDBD88;font-size:16px;">${aaa}</br>`;
              });
              return result;
            },
            padding: 20,
            textStyle: {
              fontSize: 16,
              color: 'rgba(209, 212, 220, 1)', //设置文字颜色
            },
            tooltip: {
              show: true,
            },
            extraCssText: 'background:rgba(61, 63, 71, 1);',
          },
          grid: {
            top: '4%',
            left: '0%',
            right: '1%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.assetsXData.reverse(),
            //data: ['2022-09-13', '2022-09-12', '2022-09-11', '2022-09-10', '2022-09-09', '2022-09-08', '2022-09-07'],
            offset: 12,
            axisLabel: {
              textStyle: {
                color: 'rgba(209, 212, 220, 1)',
              },
            },
          },
          yAxis: {
            type: 'log',
            //type: 'value',
            splitLine: {
              lineStyle: {
                color: ['rgba(159, 159, 159, 0.1)'],
              },
            },
            axisLabel: {
              formatter: function (v) {
                // console.log(v);
                if (v > 1000 && v <= 1000000) {
                  return v / 1000 + 'K';
                } else if (v > 1000000 && v <= 1000000000) {
                  return v / 1000000 + 'M';
                } else if (v > 1000000000) {
                  return v / 1000000000 + 'B';
                } else {
                  return v;
                }
                // return v + 'K';
              },
              textStyle: {
                color: 'rgba(209, 212, 220, 1)',
              },
              margin: 20,
            },
          },
          series: [
            {
              name: '金额',
              data: this.formatNum(this.assetsYData.reverse()),
              type: 'line',
              symbol: 'circle',
              showSymbol: false,
              lineStyle: {
                color: 'rgba(237, 189, 136, 1)',
              },
              itemStyle: {
                normal: {
                  color: 'rgba(237, 189, 136, 1)',
                },
              },
              areaStyle: {
                normal: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0.1,
                        color: 'rgba(237,189,136,0.2000)', // 0% 处的颜色
                      },
                      {
                        offset: 0.9,
                        color: 'rgba(237,189,136,0)', // 100% 处的颜色
                      },
                    ],
                    globalCoord: false, // 缺省为 false
                  },
                },
              },
            },
          ],
        };
      },
      // RTA全体用户收益情况
      earningsChange() {
        this.earningOption = {
          color: 'rgba(0, 174, 147, 1)',
          tooltip: {
            trigger: 'axis',
            borderWidth: '0', //边框宽度设置1
            borderColor: 'none', //设置边框颜色
            formatter: (params) => {
              let result = `${params[0].name}<br>`;
              params.forEach((item) => {
                var aaa = this.kmb(item.value);
                result += `${item.seriesName} : <span style="color:rgba(34, 171, 148, 1);font-size:16px;">${aaa}</br>`;
              });
              return result;
            },
            padding: 20,
            textStyle: {
              fontSize: 16,
              color: 'rgba(209, 212, 220, 1)', //设置文字颜色
            },
            tooltip: {
              show: true,
            },
            extraCssText: 'width:188px;background:rgba(61, 63, 71, 1);',
          },
          grid: {
            top: '4%',
            left: '0%',
            right: '1%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.earningXData.reverse(),
            offset: 12,
            axisLabel: {
              textStyle: {
                color: 'rgba(209, 212, 220, 1)',
              },
            },
          },
          yAxis: {
            type: 'value',
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ['rgba(159, 159, 159, 0.1)'],
              },
            },
            axisLabel: {
              formatter: function (v) {
                // console.log(v);
                if (v > 1000 && v <= 1000000) {
                  return v / 1000 + 'K';
                } else if (v > 1000000 && v <= 1000000000) {
                  return v / 1000000 + 'M';
                } else if (v > 1000000000) {
                  return v / 1000000000 + 'B';
                } else {
                  return v;
                }
                // return v + 'K';
              },
              textStyle: {
                color: 'rgba(209, 212, 220, 1)',
              },
              margin: 20,
            },
          },
          series: [
            {
              name: '金额',
              data: this.formatNum(this.earningYData.reverse()),
              type: 'line',
              symbol: 'circle',
              showSymbol: false,
              lineStyle: {
                color: 'rgba(34, 171, 148, 1)',
              },
              itemStyle: {
                normal: {
                  color: 'rgba(34, 171, 148, 1)',
                },
              },

              areaStyle: {
                normal: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0.1,
                        color: 'rgba(0, 174, 147, 0.2000)', // 0% 处的颜色
                      },
                      {
                        offset: 0.9,
                        color: 'rgba(0, 174, 147, 0)', // 100% 处的颜色
                      },
                    ],
                    globalCoord: false, // 缺省为 false
                  },
                },
              },
            },
          ],
        };
      },
    },
  };
</script>

<style lang="scss">
  body {
    margin: 0;
    padding: 0;
  }

  .content-container {
    display: flex;
    flex-direction: column;

    .header-container {
      height: 420px !important;
      background: url('../assets/img/rtaLogo/bg.png') center center no-repeat;
      background-size: cover;
      /* 背景图片不重复 */
      background-repeat: no-repeat;
      min-width: 80%;

      // min-height: 100vh;
      .banner-container {
        width: 100%;
        text-align: center;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;

        .banner {
          // padding: 0 158.5px !important;
          height: 64px !important;
          width: 100%;

          header {
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }
        }

        .brti-live-data {
          // position: absolute;
          // top: 50%;
          // left: 50%;
          // transform: translate(-50%, -9%);
          // padding: 170px 0 0 110px !important;
          text-align: left;
          width: 1130px;
          height: 316px;
          color: #ffffff;
          background: url('../assets/img/rtaLogo/bg-r.png') center center no-repeat;
          background-size: cover;

          display: flex;
          justify-content: center;
          position: relative;

          .brti-box {
            width: 1520px;
            height: 134px;
            background: url('../assets/img/rtaLogo/brti-data.svg') center center no-repeat;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, 48%);

            .brti-b {
              width: 86px;
              height: 60px;
              line-height: 60px;
              margin-right: 12px;
              font-family: Roboto-Regular, Roboto;
              font-weight: 400;
              margin-bottom: 35px;
              color: #ffffff;
              display: flex;
              flex-direction: column;
              justify-content: center;

              .brti {
                font-size: 14px;
                line-height: 16px;
              }

              .real-time {
                font-size: 12px;
                line-height: 20px;
              }
            }

            .brti-price {
              margin-bottom: 35px;
              width: 222px;
              font-size: 40px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: #ffffff;
              line-height: 60px;

              span {}
            }

            .last-time {
              margin-bottom: 35px;
              height: 60px;
              font-size: 12px;
              font-family: Roboto-Regular, Roboto;
              font-weight: 400;
              color: #ffffff;
              line-height: 16px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            }
          }
        }
      }
    }

    .body-container {
      height: 100%;
      width: 1200px;
      display: flex;
      flex-direction: column;
      text-align: center;
      margin: 0 auto;
      padding-bottom: 182px;

      .body-box {
        display: flex;
        width: 100%;
        height: 100%;

        /* 球旋转的动画 */
        @keyframes rotate_box {
          0% {
            transform: rotate3d(1, 1, 1, 0deg);
          }

          100% {
            transform: rotate3d(1, 1, 1, 360deg);
          }
        }

        .charts-container {
          width: 100%;
          height: 100%;

          .charts-box {
            text-align: left;
            margin-top: 48px;

            span {
              font-size: 28px;

              font-family: MicrosoftYaHei;
              color: #d1d4dc;
              line-height: 49px;
              cursor: pointer;
            }

            .lates-time {
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(209, 212, 220, 0.7);
              display: flex;
              align-items: flex-end;
            }

            .more-than-empty {
              color: #d1d4dc !important;
              margin-top: 20px;
              width: 800px;
              height: 492px;
              background: rgba(159, 159, 159, 0.1);
              border-radius: 8px;
              display: flex;
              flex-direction: column;

              .assets-header {
                display: flex;
                justify-content: center;
                height: 32px !important;
                margin: 20px 0;

                .assets-bnt {
                  .el-radio-group {
                    .el-radio-button {
                      width: 69px;
                      height: 32px;
                      border-radius: 16px;
                      padding: 0 !important;
                      margin: 0 !important;

                      .el-radio-button__inner {
                        width: 69px;
                        height: 32px;
                        background: transparent;
                        font-size: 13px;
                        font-family: MicrosoftYaHei;
                        color: #d1d4dc;
                        line-height: 17px;
                        border: none;
                      }

                      .el-radio-button__inner:focus {
                        background: #33353e !important;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        background: #33353e;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        border-color: none;
                        -webkit-box-shadow: none;
                        box-shadow: none;
                      }
                    }
                  }
                }
              }

              .assets-body {
                height: 100%;

                .right-control {
                  height: 120px;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  font-size: 28px;
                  line-height: 120px;
                }

                .charts {
                  padding: 0 32px;

                  .chart {
                    width: 100%;
                    height: 100% !important;
                  }
                }
              }
            }

            .exclusive-teach {
              color: #d1d4dc !important;
              margin-top: 25px;
              width: 800px;
              height: 492px;
              background: rgba(159, 159, 159, 0.1);
              border-radius: 8px;
              //opacity: 0.1;
            }
          }
        }

        .ranking-list {
          width: 100%;
          height: 100%;
          margin-left: 20px;

          .charts-box {
            text-align: left;
            margin-top: 48px;

            span {
              font-size: 28px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
              line-height: 49px;
              cursor: pointer;
            }

            .herader-banner {
              margin-top: 20px;
              width: 380px;
              height: 152px;
              //background: linear-gradient(180deg, #4f525d 0%, #33353e 100%);
              background: url('../assets/img/rtaLogo/top-banner.png');
              // border-radius: 8px 8px 0px 0px;
              display: flex;
              justify-content: space-between;

              .banner-tittle {
                margin: 36px 0 0 16px;
                font-size: 32px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: bold;
                color: #e6be8f;
                line-height: 42px;
                text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
              }

              .select-time {
                margin-top: 4px;
                line-height: 15px;
                display: flex;
                justify-content: flex-start;

                span {
                  font-size: 13px;
                  font-family: Roboto-Regular, Roboto;
                  font-weight: 400;
                  color: #999999;
                  line-height: 15px;
                }
              }
            }

            .leaderboard-button {
              width: 380px;
              height: 32px;

              .btn-margin {
                display: flex;
                // margin: 0 12px;
                justify-content: space-between;

                // height: 32px;
                .el-radio-group {
                  width: 320px;
                  display: flex;
                  flex-wrap: nowrap !important;
                  justify-content: space-between;
                  flex-wrap: wrap;

                  .el-radio-button {
                    width: 100%;
                    height: 32px;
                    margin-left: 0px !important;
                    padding: 0 0;
                    border-radius: 0px !important;

                    .el-radio-button__inner {
                      background: transparent;
                      border: none;
                      padding: 6px 10px 9px 10px;
                      font-size: 13px;
                      font-family: MicrosoftYaHei;
                      color: #d1d4dc;
                      line-height: 17px;
                    }

                    .el-radio-button__inner:focus {
                      background: linear-gradient(180deg,
                          #edbd88 0%,
                          #33353e 100%);
                      border-bottom: none;
                    }

                    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                      border-radius: 0px !important;
                      background: linear-gradient(180deg,
                          #edbd88 0%,
                          #33353e 100%);
                      border: none;
                    }

                    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                      border-color: none;
                      -webkit-box-shadow: none;
                      box-shadow: none;
                    }
                  }
                }

                .all {
                  width: 60px !important;
                  height: 32px;
                  margin-left: 0px !important;
                  padding: 0 0;
                  border-radius: 0px !important;
                  background: transparent;
                  border: none;

                  span {
                    font-size: 13px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc;
                    line-height: 16px;
                  }
                }

                .all:focus {
                  background: linear-gradient(180deg, #edbd88 0%, #33353e 100%);
                }
              }
            }

            .leaderboard {
              width: 380px;
              height: 917px;
              background: rgba(159, 159, 159, 0.1);

              border-radius: 0 0 8px 8px;

              .mine-leaderboard {
                border: 1px solid rgba(0, 0, 0, 0.1);

                .lead-box-error {
                  width: 356px;
                  height: 72px;
                  background: #33353e;
                  box-shadow: 0px 2px 19px -4px rgba(0, 0, 0, 0.3),
                    0px 2px 4px 0px rgba(0, 0, 0, 0.2),
                    0px 2px 4px 0px rgba(0, 0, 0, 0.2);
                  border-radius: 8px;
                  margin: 16px 12px 21px 12px;
                  display: flex;
                  justify-content: center;

                  span {
                    height: 72px;
                    line-height: 72px;
                    text-align: center;
                    margin: 0 auto;
                    font-size: 18px;
                    font-family: MicrosoftYaHei;
                  }
                }

                .lead-box {
                  width: 356px;
                  height: 72px;
                  background: #33353e;
                  box-shadow: 0px 2px 19px -4px rgba(0, 0, 0, 0.3),
                    0px 2px 4px 0px rgba(0, 0, 0, 0.2),
                    0px 2px 4px 0px rgba(0, 0, 0, 0.2);
                  border-radius: 8px;
                  margin: 16px 12px 21px 12px;
                  // display: flex;
                  justify-content: space-between;

                  .runk-left {
                    width: 100%;
                    display: flex;

                    .ranking {
                      width: 72px;
                      height: 48px;
                      background: linear-gradient(270deg,
                          rgba(51, 53, 62, 0) 0%,
                          #666666 150%);
                      margin-top: 12px;

                      .num {
                        margin: 13px 12px;
                        width: 48px;
                        height: 22px;
                        font-size: 20px;
                        font-family: Roboto-BoldItalic, Roboto;
                        font-weight: normal;
                        color: #d1d4dc;
                        line-height: 22px;
                        text-align: center;
                      }
                    }

                    .user {
                      display: flex;

                      .user-img {
                        img {
                          border: none !important;
                        }

                        margin: 19px 0px 19px 20px;
                        position: relative;

                        .head-portrait {
                          width: 34px;
                        }

                        .vip {
                          position: absolute;
                          top: 20px;
                          right: 2px;
                        }
                      }

                      .user-name {
                        margin: 28px 20px 28px 7px;

                        .myName {
                          font-size: 14px;
                          font-family: Roboto-Medium, Roboto;
                          font-weight: 500;
                          color: #d1d4dc;
                          line-height: 16px;
                          width: 115px;
                          white-space: nowrap !important;
                          overflow: hidden !important;
                          text-overflow: ellipsis !important;
                        }
                      }
                    }
                  }

                  .price {
                    width: 80px;
                    font-size: 14px;
                    font-family: Roboto-BoldItalic, Roboto;
                    font-weight: normal;
                    color: #d1d4dc;
                    line-height: 16px;
                    margin: 28px 8px 28px 0;
                    display: flex;
                    justify-content: flex-end;

                    span {
                      font-size: 14px;
                      font-family: Roboto-BoldItalic, Roboto;
                      font-weight: normal;
                      color: #d1d4dc;
                      line-height: 16px;
                    }
                  }
                }
              }

              .top-leaderboard {
                height: 758px;
                display: flex;
                flex-direction: column;

                .el-table {
                  background-color: transparent;

                  .el-table__empty-block {
                    display: block;
                  }

                  .el-table__header {
                    display: none;
                  }

                  .el-table__expanded-cell {
                    background-color: transparent;
                  }

                  tr {
                    background-color: transparent;

                    td {
                      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                      line-height: 71px;
                      padding: 0px;

                      .cell {
                        margin: 0px !important;
                        padding: 0px;
                        line-height: 35px;
                        height: 75px;
                      }

                      .topNo1 {
                        background: #edbd88;
                        color: #33353e;
                        width: 56px;
                        height: 32px;
                        border-radius: 0px 16px 16px 0px;
                        font-size: 14px;
                        font-family: Roboto-BoldItalic, Roboto;
                        font-weight: normal;
                        margin-top: 22px;

                        .top-num {
                          margin-left: 8px;
                        }
                      }

                      .topNo2 {
                        background: rgba(230, 191, 96, 1);
                        color: #33353e;
                        width: 56px;
                        height: 32px;
                        border-radius: 0px 16px 16px 0px;
                        font-size: 14px;
                        font-family: Roboto-BoldItalic, Roboto;
                        font-weight: normal;
                        margin-top: 22px;

                        .top-num {
                          margin-left: 8px;
                        }
                      }

                      .topNo3 {
                        background: rgba(244, 212, 151, 1);
                        color: #33353e;
                        width: 56px;
                        height: 32px;
                        border-radius: 0px 16px 16px 0px;
                        font-size: 14px;
                        font-family: Roboto-BoldItalic, Roboto;
                        font-weight: normal;
                        margin-top: 22px;

                        .top-num {
                          margin-left: 8px;
                        }
                      }

                      .top {
                        color: #d1d4dc;
                        background: #666666;
                        width: 56px;
                        height: 32px;
                        border-radius: 0px 16px 16px 0px;
                        font-size: 14px;
                        font-family: Roboto-BoldItalic, Roboto;
                        font-weight: normal;
                        margin-top: 22px;

                        .top-num {
                          margin-left: 8px;
                        }
                      }

                      .el-button {
                        display: flex;
                        padding: 0 !important;
                        height: 75px !important;

                        span {
                          display: flex;

                          .user-img {
                            margin: 19px 0px 0 0;
                            position: relative;

                            .head-portrait {
                              img {
                                width: 34px !important;
                                height: 34px !important;
                                border-radius: 50%;
                                border: 1px solid #ffffff;
                              }
                            }

                            .vip {
                              img {
                                position: absolute;
                                top: 23px;
                                right: 2px;
                                width: 32px;
                                height: 13px;
                                line-height: 13px;
                              }
                            }
                          }

                          .user-name {
                            margin: 28px 20px 28px 7px;

                            .no1 {
                              width: 115px;
                              white-space: nowrap !important;
                              overflow: hidden !important;
                              text-overflow: ellipsis !important;
                              font-size: 14px;
                              font-family: Roboto-Medium, Roboto;
                              font-weight: 500;
                              line-height: 16px;
                              color: rgba(237, 189, 136, 1) !important;
                              text-align: left !important;
                            }

                            .no {
                              width: 115px;
                              white-space: nowrap !important;
                              overflow: hidden !important;
                              text-overflow: ellipsis !important;
                              font-size: 14px;
                              font-family: Roboto-Medium, Roboto;
                              font-weight: 500;
                              color: #d1d4dc;
                              line-height: 16px;
                              text-align: left !important;
                            }
                          }
                        }
                      }

                      .price {
                        font-size: 14px;
                        font-family: Roboto-BoldItalic, Roboto;
                        font-weight: normal;
                        color: #d1d4dc;
                        line-height: 16px;
                        margin: 30px 20px 0 0;
                        display: flex;
                        font-style: italic;
                        justify-content: flex-end;

                        span {
                          font-size: 14px;
                          font-family: Roboto-BoldItalic, Roboto;
                          font-weight: normal;
                          color: #d1d4dc;
                          line-height: 16px;
                        }
                      }
                    }
                  }
                }

                .el-table--enable-row-hover .el-table__body tr:hover>td {
                  background: rgba(255, 255, 255, 0.1) !important;
                  color: #33353e;
                }

                .el-table--enable-row-transition .el-table__body td,
                .el-table .cell {
                  background-color: transparent;
                }
              }

              .leaderboard-btn {
                border-top: 1px solid rgba(0, 0, 0, 0.1);
                text-align: center;

                .el-button {
                  width: 100%;
                  height: 48px;

                  span {
                    font-size: 12px;
                    font-family: MicrosoftYaHei;
                    color: #edbd88;
                    line-height: 16px;
                  }
                }
              }
            }
          }
        }

        .container-row {
          width: 100%;
          height: 100%;

          .charts-box {
            text-align: left;
            margin-top: 48px;

            span {
              font-size: 28px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
              line-height: 49px;
              cursor: pointer;
            }

            .exclusive-teach {
              color: #d1d4dc !important;
              margin-top: 25px;
              width: 100%;
              height: 360px;
              background: rgba(159, 159, 159, 0.1);
              border-radius: 8px;
            }

            .total-user-assets {
              color: #d1d4dc !important;
              margin-top: 25px;
              width: 100%;
              height: 571px;
              background: rgba(159, 159, 159, 0.1);
              border-radius: 8px;

              .assets-header {
                padding: 24px 20px;
                display: flex;
                justify-content: space-between;

                .assets-tittle {
                  .accumulated {
                    font-size: 18px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc;
                    line-height: 24px;
                  }

                  .price {
                    width: 222px;
                    height: 44px;
                    font-size: 36px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #edbd88;
                    line-height: 44px;
                    margin-top: 8px;
                  }

                  .price-user {
                    color: rgba(34, 171, 148, 1);
                  }

                  .data {
                    font-size: 13px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: #d1d4dc;
                    line-height: 15px;
                    margin-top: 8px;

                    span {
                      font-size: 13px;
                      font-family: Roboto-Regular, Roboto;
                      font-weight: 400;
                      color: #d1d4dc;
                      line-height: 15px;
                    }
                  }
                }

                .assets-bnt {
                  .el-radio-group {
                    .el-radio-button {
                      width: 66px;
                      height: 32px;
                      border-radius: 16px;
                      padding: 0 !important;
                      margin: 0 !important;

                      .el-radio-button__inner {
                        width: 69px;
                        height: 32px;
                        background: transparent;
                        font-size: 13px;
                        font-family: MicrosoftYaHei;
                        color: #d1d4dc;
                        line-height: 17px;
                        border: none;
                      }

                      .el-radio-button__inner:focus {
                        background: #33353e !important;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        background: #33353e;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        border-color: none;
                        -webkit-box-shadow: none;
                        box-shadow: none;
                      }
                    }
                  }
                }

                .box-he {
                  display: flex;
                  justify-content: space-between;

                  .dotmapDate {
                    display: flex;

                    .ditmap-i {
                      width: 16px;
                      height: 22px;
                      line-height: 22px;
                      display: flex;
                      align-items: center;

                      i {
                        font-size: 16px;
                      }
                    }

                    .el-date-editor {
                      width: 113px;

                      .el-input__inner {
                        padding: 0 !important;
                        text-align: center;
                        border: none;
                        background: transparent;
                        height: 22px !important;
                        font-size: 16px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: #d1d4dc;
                        line-height: 22px;
                      }

                      .el-input__prefix {
                        display: none;
                      }

                      .el-input__suffix {
                        display: none;
                      }
                    }
                  }

                  .r-switch {
                    display: none;
                    // margin-left: 24px !important;
                    height: 22px !important;
                    line-height: 22px;

                    .el-switch {
                      justify-content: flex-end;
                      width: 53px !important;
                      height: 22px !important;
                      line-height: 22px;

                      .el-switch__core {
                        left: 1px;
                        top: 1px;
                        width: 29px !important;
                        height: 20px !important;
                        line-height: 20px;
                        border-color: transparent !important;
                        background: url('../assets/img/rtaLogo/switch.png') no-repeat;
                      }

                      .el-switch__core:after {
                        content: '';
                        position: absolute;
                        top: -3px;
                        left: 9px;
                        border-radius: 100%;
                        -webkit-transition: all 0.3s;
                        transition: all 0.3s;
                        width: 20px;
                        height: 20px;
                        background: url('../assets/img/rtaLogo/switch-big-roung.png') no-repeat;
                      }
                    }

                    .is-checked {
                      .el-switch__core {
                        width: 16px !important;
                        left: 1px;
                        top: -1px;
                        height: 14px !important;
                        background: url('../assets/img/rtaLogo/switch-roung.png') no-repeat;
                      }

                      .el-switch__core:after {
                        left: 2px;
                        top: -3px;
                        background: url('../assets/img/rtaLogo/switch-big.png') no-repeat;
                      }
                    }
                  }
                }
              }

              .dotmapDate-box {
                justify-content: flex-end;
                padding: 24px 32px !important;
              }

              .dotmap-body {
                padding: 24px 32px !important;
              }

              .assets-body {
                .right-control {
                  height: 120px;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  font-size: 28px;
                  line-height: 120px;
                }

                .charts {
                  padding: 0 32px;
                }

                .introducerKind {
                  .chart-display {
                    display: flex;

                    .aa {
                      display: flex;

                      .cycle {
                        tr {
                          // th {
                          //   padding-right: 20px;
                          //   height: 87px;
                          //   line-height: 87px;
                          //   position: relative;
                          //   .long-box {
                          //     height: 87px;
                          //     line-height: 87px;
                          //     position: absolute;
                          //     //left: 1px;
                          //     top: -43px;

                          //     .long {
                          //     }
                          //   }
                          //   .neutral-box {
                          //     text-align: left !important;
                          //     .neutral {
                          //     }
                          //   }
                          //   .short-box {
                          //     position: absolute;
                          //     //left: 1px;
                          //     top: 70px;
                          //     .short {
                          //     }
                          //   }
                          // }
                          .box-te {
                            border-top: none;
                            border-right: none;
                            width: 56px !important;

                            .neutral-box {
                              text-align: left !important;

                              .neutral {}
                            }
                          }

                          .long-box-te {
                            position: relative;
                            border-top: none;
                            border-right: none;
                            width: 56px !important;

                            .long-box {
                              height: 87px;
                              line-height: 87px;
                              position: absolute;
                              //left: 1px;
                              top: -43px;

                              .long {}
                            }

                            .neutral-box {
                              text-align: left !important;
                              position: absolute;
                              top: 25px;

                              .neutral {}
                            }

                            .short-box {
                              position: absolute;
                              //left: 1px;
                              top: 70px;

                              .short {}
                            }
                          }

                          td {
                            border-top: 1px solid rgba(255, 255, 255, 0.1);
                            border-right: 1px dashed rgba(255, 255, 255, 0.1);
                            width: 360px;
                            height: 100%;
                            // line-height: 87px;
                            text-align: center;

                            .vote-container {
                              display: flex;
                              justify-content: center;
                              margin: 24px 14px 16px 26px;
                              height: calc(92px - 24px - 16px);

                              .vote {
                                margin-right: 12px;
                                display: flex;
                                flex-direction: column;
                                align-items: center;

                                img {
                                  width: 32px;
                                  height: 32px;
                                  border-radius: 50px;
                                }

                                .num {
                                  width: 100%;
                                  height: 19px;
                                  line-height: 19px;
                                  font-size: 16px;
                                  font-family: DIN-Bold, DIN;
                                  font-weight: bold;
                                  color: #00ae93;
                                }
                              }
                            }

                            .vote-containe-round {
                              display: flex;
                              justify-content: center;
                              margin: 24px 14px 16px 26px;
                              height: calc(92px - 24px - 16px) !important;

                              .vote {
                                margin-right: 12px;
                                display: flex;
                                justify-content: center;
                                flex-direction: column;
                                align-items: center;
                                height: 51px;

                                .round {
                                  width: 16px;
                                  height: 16px;
                                  border-radius: 50px;
                                  background: linear-gradient(180deg,
                                      #efc394 0%,
                                      #f8e3c6 100%);
                                }
                              }
                            }
                          }

                          .cy {
                            border-right: none !important;
                            height: 62px;
                            line-height: 62px;
                          }
                        }
                      }

                      .cycle-long {
                        td {
                          border-right: none !important;
                        }
                      }
                    }
                  }
                }

                .dotmap-tittle {
                  width: 100%;
                  text-align: right;
                  // span {
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 0.7);
                  // }
                }
              }
            }

            .dotmapDate-container {
              height: 100% !important;
            }
          }
        }
      }
    }
  }

  .permissions_alert {
    .el-message-box__content {
      padding: 0 22px !important;
    }
  }

  .dotmapPicker {
    // width: 288px;
    // height: 243px;
    background: rgba(51, 53, 62, 1) !important;
    border-radius: 4px;
    border: rgba(51, 53, 62, 1);
    box-shadow: 0px 0px 20px -6px rgba(0, 0, 0, 0.5);
    border-radius: 8px;

    .el-picker-panel__body-wrapper {
      .el-picker-panel__body {
        .el-date-picker__header {
          border-bottom: 1px solid rgba(255, 255, 255, 0.12);
          margin: 0px !important;
          padding: 8px 16px;

          .el-picker-panel__icon-btn {
            color: #d1d4dc;
          }

          .el-date-picker__header-label {
            font-size: 14px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #d1d4dc;
          }
        }

        .el-picker-panel__content {
          .el-date-table {
            th {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
              border: none !important;
            }

            td {
              span {
                font-size: 14px;
                font-family: Roboto-Regular, Roboto;
                font-weight: 400;
                color: #ffffff;
              }
            }

            .disabled {
              div {
                background-color: transparent !important;

                span {
                  color: rgba(209, 212, 220, 0.5);
                }
              }
            }

            td.current:not(.disabled) span {
              width: 24px;
              height: 24px;
              background: #efc394;
              border-radius: 2px;
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue